import { module } from 'angular';

import { default as osvServiceName, OsvService } from './osv.service';

export default module('contact.agent.core.channel-digit.softphone.osv', [])
  // instanciate services module
  .run([osvServiceName, () => {}])
  // service
  .service(osvServiceName, OsvService).name;
